<template>
    <div>
        <d-contract-zus-edit
            v-model      = "edit"
            :contract-id = "contract ? contract.id : null"
            :company-id  = "contract && contract.company ? contract.company.id : null"
            @saved       = "onSaved"
        />

        <c-list-card
            :icon       = "icon"
            :background = "background"
            :height     = "107"
            @edit       = "onEdit"
            @selected   = "onSelect"
        >
            <template v-slot:title>
                <div>
                    <span class="primary--text">
                        {{ contract.id }} - {{ date (contract.start) }} bis {{ date (contract.expiration) }}
                    </span>
                </div>
                <v-spacer></v-spacer>
                <company-tag
                    :label   = "$t('msd.service.role.srv.label')"
                    :active  ="contract.active"
                    :company = "contract.company"
                />
            </template>

            <template v-slot:subtitle>
                {{ contract.customer.name }}
            </template>

            <template v-slot:body>
                <p-contract-condition
                    class="mt-2"
                    :contract = "contract"
                />
            </template>

        </c-list-card>
    </div>
</template>

<script>
import Core             from "@/modules/core/service/Core";
import CListCard        from "@/modules/core/components/utils/CListCard";
import CompanyTag       from "@/modules/msd/company/common/components/controlls/CompanyTag";
import DContractZusEdit from "@/modules/msd/company/contract/components/controls/zus/DContractZusEdit";
import PContractCondition from "@/modules/msd/company/contract/components/controls/common/PContractCondition.vue";

export default {
    name: "CContractZusCard",
    components: {
        PContractCondition,
        DContractZusEdit,
        CompanyTag,
        CListCard,
    },

    props: {
        contract: {

        },

        background: {
            required: false,
            type    : String,
            default : function () {
                return null;
            }
        },
    },

    data: () => ({
        edit: false,
    }),

    computed: {
        icon() {
            return {
                label: "ZÜS",
                active: this.contract.active,
            }
        },
    },

    methods: {
        onSelect () {
            Core.fire.selected(this, this.contract);
        },

        onEdit () {
            this.edit = true;
        },

        onSaved (contract) {
            Core.fire.saved(this, contract);
        },

        toHtml (text) {
            return Core.format.html(text);
        },

        money (value) {
            if (!value) {
                return "---";
            }

            return Core.format.money(value);
        },

        date (value) {
            return Core.format.date.sdisplay(value);
        },
    }
}
</script>

<style scoped>

.card-subtitle {
    font-size: 13px;
}

.card-subtitle-add {
    font-size: 13px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.contract-type {
    margin-right: 10px;
    padding-right: 10px;
    padding-left: 10px;
    padding-top: 3px;
    border-radius: 5px;
    color: white;
    font-size: 12px;
}

.recipient-icon {
    margin-left: 2px;
}

::v-deep .v-card--link:focus:before {
    opacity: 0.0!important;
}

.right {
    text-align: right;
}


</style>